<template>
		<div class="content crfff home-page">
      <Header></Header>
      <div class="info">
        <div class="nav mt50 ac">
          <span class="">{{$t('profile')}}</span>
        </div>
        <div class="mt20 ac">
          <img style="width: 10rem"  src="static/images/account.png" />
        </div>
        <div class="ac">
          <div v-if="isEdit" class="flex" style="margin:20px 0;">
            <input class="fen" style="margin:0px 10px 0 0;width:70%;font-size: 28px;color:#fff" v-model="nickname" />
            <button class="button" style="width: 60%;" @click="editSub">{{$t('Submit')}}</button>
          </div>
          <div v-else>
            <span class="name-span app-en">{{info.nickname}}</span>
            <span class=" crff1d4f fs33" @click="editName">
              <img style="width: 1rem" class="edit" src="static/images/edit.png" />
            </span>
          </div>
        </div>
        <div class="mt100">
          <div class="fwb">
            <div class="name fw7 fs20">
             {{$t('phoneNumber')}}
            </div>
            <div class="fen">
              <span class="fs26">{{info.mobile}}</span>
            </div>
          </div>
          <div class="fwb">
            <div class="name fw7 fs20">
              {{$t('SubscribedSince')}}
            </div>
            <div class="fen">
              <span class="fs26">{{info.jointime}}</span>
            </div>
          </div>
          <div class="fwb">
            <div class="name fw7 fs20">
              {{$t('RemainingChances')}}
            </div>
            <div class="fen">
              <span class="fs26">{{info.score}}</span>
            </div>
          </div>
        </div>
			</div>
		</div>
</template>
<script>
import Header from '../components/Header'
import Dialog from '../components/dialog'

export default {
    components:{
		Header,
    Dialog
    },
    data() {
        return {
          disAbled:'',
          isEdit:false,
          info:'',
          nickname:'',

        }
    },
	watch: {

	},
	computed:{
	},
    mounted() {
		let that = this;
    },
	created(){
		this.getHome();

	},
    methods: {
		back(){
			this.$router.go(-1);
		},
    editName(){
      this.isEdit = true
      this.nickname = this.info.nickname
    },
    editSub(){
      let that =this;
      let data = {
        nickname:that.nickname
      }
      //that.$parent.loadModal(true);
      that.$api.post('/api/user/profile',data,r =>{
      	that.$parent.returnCode(r,function(){
      		//that.info = r.data
          that.isEdit = false
          that.getHome()
      		that.$parent.loadModal(false);
        });

      })
    },
		getHome(){
			let that =this;
			//that.$parent.loadModal(true);
			that.$api.post('/api/user/info',null,r =>{
				that.$parent.returnCode(r,function(){
					that.info = r.data
					that.$parent.loadModal(false);
        });

			})
		},
	}
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/page/myAccount.vue